import { Call } from "@stream-io/video-client";

// Icons
const MIC_ON = `<svg viewBox="0 0 24 24"><path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/><path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/></svg>`;
const CAM_ON = `<svg viewBox="0 0 24 24"><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/></svg>`;
const SCREEN_SHARE = `<svg viewBox="0 0 24 24"><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/></svg>`;
const CAM_FLIP = `<svg viewBox="0 0 24 24"><path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"/></svg>`;
const SETTINGS = `<svg viewBox="0 0 24 24"><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L3.16 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.04.24.24.41.48.41h3.84c.24 0 .43-.17.47-.41l.36-2.54c.59-.24 1.13-.57 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>`;
const LEAVE = `<svg viewBox="0 0 24 24"><path d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"/></svg>`;
const CHAT_ICON = `<svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/></svg>`;

const createBtn = (iconSvg: string, className = "") => {
  const btn = document.createElement("button");
  btn.className = `control-btn ${className}`;
  btn.innerHTML = iconSvg;
  return btn;
};

export const renderControls = (call: Call, onLeave?: () => void) => {
  // Audio
  const audioButton = createBtn(MIC_ON);
  audioButton.addEventListener("click", () => call.microphone.toggle());
  call.microphone.state.status$.subscribe((status) => {
     audioButton.classList.toggle("off", status === "disabled");
  });

  // Video
  const videoButton = createBtn(CAM_ON);
  videoButton.addEventListener("click", () => call.camera.toggle());
  call.camera.state.status$.subscribe((status) => {
     videoButton.classList.toggle("off", status === "disabled");
  });

  // Chat Button
  const chatButton = createBtn(CHAT_ICON);

  // Screen Share
  const screenShareButton = createBtn(SCREEN_SHARE);
  screenShareButton.addEventListener("click", () => call.screenShare.toggle());
  call.screenShare.state.status$.subscribe((status) => {
     screenShareButton.classList.toggle("active", status === "enabled");
  });

  // Flip (Mobile)
  const flipButton = createBtn(CAM_FLIP);
  flipButton.addEventListener("click", () => call.camera.flip());

  // Settings
  const settingsButton = createBtn(SETTINGS);
  
  // Leave - UPDATED
  const leaveButton = createBtn(LEAVE, "danger");
  if (onLeave) {
    leaveButton.addEventListener("click", onLeave);
  }

  return { 
    audioButton, 
    videoButton, 
    screenShareButton, 
    flipButton, 
    settingsButton,
    leaveButton,
    chatButton
  };
};